<template>
  <div style="padding: 20px">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="列表采集">
        <ListCollect />
      </a-tab-pane>
      <a-tab-pane key="2" tab="词条采集">
        <WordCollect />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import ListCollect from './ListCollect/'
import WordCollect from './WordCollect/'
export default {
  components: {
    ListCollect,
    WordCollect
  }
}
</script>

<style></style>
